import ProductPage from './views/ProductPage.vue'

const route = [
  {
    path: '/page-produit',
    name: 'productpage',
    component: ProductPage,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A','R','C','I']
    },
    props: true
  }
]

export default route